import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { DialogService } from "../../Shared/dialog.service";
import { ParamMap, Router, ActivatedRoute } from "@angular/router";
declare var $: any;
import { LmsService } from "../../_Lms/services/lms.service";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";



@Component({
  selector: 'app-product-notif-config',
  templateUrl: './product-notif-config.component.html',
  styleUrls: ['./product-notif-config.component.scss']
})
export class ProductNotifConfigComponent implements OnInit {
  private _MasterService; 
    data: any;
  showSpinner: boolean = false;
  loading: boolean = false;
    ProductId: any = 0;
      FilterProductId: any = "";
  ProcessDropdown: any = [];
   SelectProductCategory: any = "";
  ProductName: string = "";
  ProductShortName: string = "";
  ProductCategoryDropdown: any = [];
   IsUpdate: boolean = false;
  IsEdit: boolean = false;
  IsDisabled: boolean = false;
  IsDisabledAccount: boolean = false;
  MailTemplateDropdown: any[] = [];
  EventNameDropdown: any[] = [];
  SMS_StepName_Dropdown: any[] = [];
  WhatsAppStepNameDropdown: any[] = [];
  EventConfiguration: any;
  TemplateId: any;
  EventHead: any[] = [];
  EventConfigRows: any[] = [];
  IsSave: boolean = false;
  Event_Id: any = ""
   configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };


  constructor(
    private dataSharingService: DataSharingService,
    private route: ActivatedRoute,
    private dialog: DialogService,
    private _EncrDecrService: EncrDecrService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private lmsService: LmsService,
    private _QuickLoanService: QuickLoanService
  ) { 
    this._MasterService = MasterService;
  }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Notif Config");
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
    this.route.paramMap.subscribe((param: ParamMap) => {
      this.FilterProductId = this._EncrDecrService.decrypt(
        decodeURIComponent(param.get("Id"))
      );
            this.getProductDetail();

      // if (this.ProductId) {
      //   this.QuickLoan_Get_ProcessLevel();
      // }
    });
    // this.getPageLoad();
    this.GetTemplateList();
    this.Get_EventList();
    this.Get_SMS_StepNameList();
    this.Get_WhatsApp_StepNameList();
    this.GetProductEventConfiguration();
    // this.loadNotificationConfig();

  }
   getProductCategory() {
    this.MasterService.GetProductCategory().subscribe((result) => {
      this.ProductCategoryDropdown = JSON.parse(JSON.stringify(result));
    });
  }
   getProductDetail() {
    this._MasterService.GetProductListById({ ProductId: this.FilterProductId }).subscribe((result) => {
      if (result.length > 0) {
        this.SelectProductCategory = result[0].ProductCatId;
        this.ProductName = result[0].Product;
        this.ProductShortName = result[0].ShortName;
      }
    });
  }
   QuickLoan_Get_ProcessLevel() {
    this._QuickLoanService
      .QuickLoan_Get_ProcessLevel({ ProductId: this.ProductId })
      .subscribe((res: any) => {
        console.log("res", res);
        this.ProcessDropdown = res;
      });
  }
  GetTemplateList() {
    this.showSpinner = true;
    this.MasterService.Get_Mail_Template().subscribe({
      next: (result: any) => {
        this.MailTemplateDropdown = result || [];
        this.showSpinner = false;
        console.log("abc", result);
      },
      error: () => {
        this.showSpinner = false;
      },
    });
  }
  Get_EventList() {
    this.showSpinner = true;
    this.MasterService.Get_Event().subscribe({
      next: (result: any) => {
        this.EventNameDropdown = result || [];
        this.showSpinner = false;
        
      },
      error: () => {
        this.showSpinner = false;
      },
    });
  }
  Get_SMS_StepNameList() {
    this.showSpinner = true;
    this.MasterService.Get_SMS_StepName().subscribe({
      next: (result: any) => {
        this.SMS_StepName_Dropdown = result || [];
        this.showSpinner = false;
        console.log("abc", result);
      },
      error: () => {
        this.showSpinner = false;
      },
    });
  }
  Get_WhatsApp_StepNameList() {
    this.showSpinner = true;
    this.MasterService.Get_WhatsApp_StepName().subscribe({
      next: (result: any) => {
        this.WhatsAppStepNameDropdown = result || [];
        this.showSpinner = false;
        console.log("abc", result);
      },
      error: () => {
        this.showSpinner = false;
      },
    });
  }
  

  onSaveNewProduct(){
    this.saveEventConfig();
  }
  
  GetProductEventConfiguration() {
  this.MasterService
    .Get_Event_Configuration({ ProductId: this.FilterProductId })
    .subscribe((res: any[]) => {

      // 🆕 New product → one empty row
      if (!res || res.length === 0) {
        this.EventConfigRows = [this.createEmptyEventRow()];
        this.IsEdit = false;
        this.IsDisabled = false;
        this.IsUpdate = false;
        this.IsSave = true;
        return;
      }

      // Existing configs
      this.EventConfigRows = res.map(obj => ({
        Event_Id: obj.Event_Id,
        ProductId: this.ProductId,
        LoginUserId: this.data.userId,

        SMS_Step_Id: obj.SMS_Step_Id ? String(obj.SMS_Step_Id) : "",
        WhatsApp_Step_Id: obj.WhatsApp_Step_Id ? String(obj.WhatsApp_Step_Id) : "",
        Mail_Step_Id: obj.Mail_Step_Id ? String(obj.Mail_Step_Id) : "",

        IsSMSActive: obj.IsSMSActive,
        IsEmailActive: obj.IsEmailActive,
        IsWhatsAppActive: obj.IsWhatsAppActive,

        Type: 'Old'
      }));

      this.IsEdit = true;
      this.IsDisabled = true;
      this.IsUpdate = false;
    });
}
onEditConfig() {
    this.IsEdit = false;
    this.IsUpdate = true;
    this.IsDisabled = false;
    // this.IsDisabledAccount = true;
  }


  // GetProductEventConfiguration(){
  //   this.MasterService
  //     .Get_Event_Configuration({
  //       ProductId: 1
  //     })
  //     .subscribe((res: any) => {
  //       this.EventHead.forEach((obj: any) => {
  //          let _find = res.find((ele: any) => {
  //           return ele.Event_Id == obj.Id;
  //         });
  //         if (_find) {
  //           // obj.select = true;
  //           obj.Event_Id = obj.Id;
  //           obj.ProductId = this.ProductId;
  //           obj.LoginUserId = this.data.userId;
  //           obj.SMS_Step_Id = _find.SMS_Step_Id;
  //           // obj.Apply_ProcessId = _find.Apply_ProcessId;
  //           obj.WhatsApp_Step_Id = _find.WhatsApp_Step_Id;
  //           obj.Mail_Step_Id = _find.Mail_Step_Id;
  //           obj.IsSMSActive = _find.IsSMSActive;
  //           obj.IsEmailActive = _find.IsEmailActive;
  //           obj.IsWhatsAppActive =_find.IsWhatsAppActive;

  //         }else{
  //           obj.Event_Id = obj.Id;
  //           obj.ProductId = this.ProductId;
  //           obj.LoginUserId = this.data.userId;
  //           obj.SMS_Step_Id = "";
  //           // obj.Apply_ProcessId = "";
  //           obj.WhatsApp_Step_Id = "";
  //           obj.Mail_Step_Id = "";
  //           obj.IsSMSActive = false;
  //           obj.IsEmailActive =false;
  //           obj.IsWhatsAppActive =false;
  //         }
  //       })
  //       this.EventConfiguration = res
  //     })
  // }
  createEmptyEventRow() {
  return {
    Event_Id: null,
    ProductId: this.ProductId,
    LoginUserId: this.data.userId,

    SMS_Step_Id: "",
    WhatsApp_Step_Id: "",
    Mail_Step_Id: "",

    IsSMSActive: false,
    IsEmailActive: false,
    IsWhatsAppActive: false,

    Type: 'New'
  };
}

addEventRow() {
  this.EventConfigRows.push(this.createEmptyEventRow());
}
removeEventRow(index: number) {
  this.EventConfigRows.splice(index, 1);
}

// saveEventConfig() {
//   if (!this.EventConfigRows || this.EventConfigRows.length === 0) {
//     return;
//   }

//   const payload = this.EventConfigRows.map(row => ({
//   Event_Id: Number(row.Event_Id) || 0,
//   ProductId: Number(this.FilterProductId),
//   LoginUserId: Number(this.data.userId),

//   SMS_Step_Id: row.SMS_Step_Id ? Number(row.SMS_Step_Id) : null,
//   Mail_Step_Id: row.Mail_Step_Id ? Number(row.Mail_Step_Id) : null,
//   WhatsApp_Step_Id: row.WhatsApp_Step_Id ? Number(row.WhatsApp_Step_Id) : null,

//   IsSMSActive: row.IsSMSActive === true,
//   IsEmailActive: row.IsEmailActive === true,
//   IsWhatsAppActive: row.IsWhatsAppActive === true
// }));

//   this.showSpinner = true;

//   this.MasterService.Save_Event_Configuration(payload).subscribe({
//     next: (res: any) => {
//       this.showSpinner = false;

//       this.snackBar.openFromComponent(SnackbarComponent, {
//         data: { message: 'Event configuration saved successfully' },
//         duration: 3000,
//         panelClass: ['snackbar-success']
//       });

//       // reload & lock form
//       this.GetProductEventConfiguration();
//     },
//     error: () => {
//       this.showSpinner = false;

//       this.snackBar.openFromComponent(SnackbarComponent, {
//         data: { message: 'Failed to save configuration' },
//         duration: 3000,
//         panelClass: ['snackbar-error']
//       });
//     }
//   });
// }
saveEventConfig() {
  if (!this.EventConfigRows || this.EventConfigRows.length === 0) {
    return;
  }

  const data = this.EventConfigRows.map(row => ({
    Event_Id: Number(row.Event_Id) || 0,

    SMS_Step_Id: row.SMS_Step_Id ? Number(row.SMS_Step_Id) : null,
    Mail_Step_Id: row.Mail_Step_Id ? Number(row.Mail_Step_Id) : null,
    WhatsApp_Step_Id: row.WhatsApp_Step_Id ? Number(row.WhatsApp_Step_Id) : null,

    IsSMSActive: row.IsSMSActive === true,
    IsEmailActive: row.IsEmailActive === true,
    IsWhatsAppActive: row.IsWhatsAppActive === true
  }));

  const payload = {
    JSON: JSON.stringify({ Data: data }),
    ProductId: Number(this.FilterProductId),
    LoginUserId: Number(this.data.userId)
  };

  this.showSpinner = true;

  this.MasterService.Save_Event_Configuration(payload)
    .subscribe((response) => {
        if (response[0].CODE >= 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].Msg,
            ...this.configSuccess,
          });
            this.showSpinner = false;

      this.GetProductEventConfiguration();
    } else
      {this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].Msg,
            ...this.configSuccess,
          });}
    
  });
}

canAddRow(row: any): boolean {
  if (!row) {
    return false;
  }

  const eventSelected = !!row.Event_Id;

  const atLeastOneTemplateSelected =
    !!row.SMS_Step_Id ||
    !!row.Mail_Step_Id ||
    !!row.WhatsApp_Step_Id;

  return eventSelected && atLeastOneTemplateSelected;
}
getSelectedEventIds(excludeIndex?: number): number[] {
  return this.EventConfigRows
    .filter((_, i) => i !== excludeIndex)
    .map(r => Number(r.Event_Id))
    .filter(id => id > 0);
}
getFilteredEventList(rowIndex: number) {
  const selectedIds = this.getSelectedEventIds(rowIndex);

  return this.EventNameDropdown.filter(ev =>
    !selectedIds.includes(Number(ev.Id))
  );
}



  

}
